import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Testimonials = () => {
  const reviews = [
    {
      name: "Daniel",
      username: "daniel_slovak",
      platform: "instagram",
      link: "https://www.instagram.com/daniel_slovak/",
      review: "ViralGPT's Instagram targeting is incredible. I grew from 10k to 40k real followers in 3 months by reaching people who love fitness content like mine.",
      image: "https://i.imgur.com/mQyhndN.jpeg",
    },
    {
      name: "Sarah Williams", 
      username: "sarah_williams",
      platform: "youtube",
      link: "https://youtube.com/sarah_williams/",
      review: "As a YouTuber, I was struggling to get real subscribers. ViralGPT helped me grow from 5k to 50k subs by targeting viewers interested in my cooking content.",
      image: "https://media.licdn.com/dms/image/v2/D5603AQEyTxdvA52TmA/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1724275003322?e=2147483647&v=beta&t=6H8mWFgjA0QLqTEBdVYXo_3Wh0JA4QSno7N2sw9PJ-0",
    },
    {
      name: "Marcus Johnson",
      username: "marcus_johnson", 
      platform: "tiktok",
      link: "https://tiktok.com/@marcus_johnson/",
      review: "TikTok growth was hard until I found ViralGPT. Their AI helped my dance videos reach the right audience and I hit 200k followers in 6 months!",
      image: "https://randomuser.me/api/portraits/men/56.jpg",
    },
    {
      name: "John Craner",
      username: "john_craner",
      platform: "x",
      link: "https://x.com/john_craner/",
      review: "ViralGPT's X targeting is next level. My tech tweets now reach the perfect audience and I've grown to 75k engaged followers who actually interact.",
      image: "https://randomuser.me/api/portraits/men/32.jpg", 
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
	<>
	<hr></hr>
    <section id="testimonials" className="pt-4 bg-gray-50  mx-auto px-4 text-center">

      <div className="bg-gray-50">
        <div className="tracking-wide	 text-2xl  font-bold ">Over 30,000+ Influencers Use <span className="text-instagram font-bold">ViralGPT</span></div>
		<div className="tracking-wide	 text-lg text-gray-800 mb-8 ">From Top Brands to Rising Influencers!</div>

        <div className="overflow-hidden max-w-full justify-content-center text-center">
          <Slider {...settings}>
            {reviews.map((review, index) => (
              <div key={index} className="p-6 w-full bg-gray-50 rounded">
                <a href={review.link} target="_blank" rel="noopener noreferrer">
                  <img
                    src={review.image}
                    alt={review.name}
                    className="rounded-full mx-auto"
                    style={{width: "100px", height: "100px"}}
                  />
                </a>
                    
                <br/>
                <div className="bg-white rounded p-2 text-center max-w-sm mx-auto">
                  <div className="mt-2 text-black font-semibold">
                    <span className="text-lg">{review.name}</span>
                    <div className="text-sm text-gray-500">
                      <a 
                        href={review.link}
                        target="_blank" 
                        rel="noopener noreferrer"
                       
                      >
                        {review.platform === "x" ? (
                          <span className="bg-black px-1 rounded-md text-white mr-1">𝕏</span>
                        ) : review.platform === "instagram" ? (
                          <i className="fab fa-instagram text-instagram mr-1"></i>
                        ) : review.platform === "tiktok" ? (
                          <span className="bg-black  p-1 rounded-md text-white mr-1"><i className="fab fa-tiktok"></i></span>
                        ) : review.platform === "youtube" ? (
                          <i className="fab fa-youtube text-red-600 mr-1"></i>
                        ) : (
                          <i className={`fab fa-${review.platform} mr-1`}></i>
                        )}
                        @{review.username}
                      </a>
                    </div>
                  </div>
                  <p className="text-gray-500 rounded mt-2">{review.review}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

	  <div className="text-center bg-gray-50  pt-3  relative overflow-hidden h-24">
		<div className="tech-slideshow  absolute left-0 top-0 w-full h-full">
			<div className="mover-1   flex items-center h-full">
				<img src="https://rizzup.net/images/roobet.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/bud.com.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/mctrades.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/TTM-Logo.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/roobet.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/bud.com.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/mctrades.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/TTM-Logo.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/roobet.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/bud.com.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/mctrades.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/TTM-Logo.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/roobet.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/bud.com.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/mctrades.webp" style={{"height":"50px"}} class="px-4"/>
				<img src="https://rizzup.net/images/TTM-Logo.webp" style={{"height":"50px"}} class="px-4"/>
			</div>
			
		</div>
		</div>
		<hr/>
    <div className="bg-gray-50 mt-10 mb-16 py-8">
      <div className="max-w-screen-xl mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-900">More Followers = More Profit</h2>
          <p className="mt-4 text-xl text-gray-600">Build trust and credibility with a larger following</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <div className="text-center mb-4">
              <i className="fas fa-handshake text-4xl text-instagram"></i>
              <h3 className="text-xl font-bold mt-3">Brand Collaborations</h3>
            </div>
            <p className="text-gray-600">
              Attract paid brand deals and sponsorship opportunities from companies by having a larger following.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            <div className="text-center mb-4">
              <i className="fas fa-link text-4xl text-instagram"></i>
              <h3 className="text-xl font-bold mt-3">More Bio Link Clicks</h3>
            </div>
            <p className="text-gray-600">
              Having more followers increases the number of profile visitors who click your bio link, driving more sales to your store.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            <div className="text-center mb-4">
              <i className="fas fa-chart-line text-4xl text-instagram"></i>
              <h3 className="text-xl font-bold mt-3">Higher Conversion</h3>
            </div>
            <p className="text-gray-600">
             A larger following builds social proof and credibility. People are more likely to buy from accounts with an established presence.
            </p>
          </div>
        </div>

        <div className="text-center mt-8">
          <a href="/register" className="inline-block bg-instagram text-white font-bold py-3 px-8 rounded-lg hover:opacity-90 transition-opacity">
            Grow Your Brand <i className="fas fa-arrow-right ml-2"></i>
          </a>
        </div>
      </div>
    </div>
    </section>
	</>
  );
};

export default Testimonials;
